angular.module('impactx.tender').controller('TenderCtrl', TenderController);
TenderController.$inject = [
    '$scope',
    '$sce',
    'dataGen',
    '$routeParams',
    'searchFilter',
    '$redirect',
    'panelService',
    'RFXCreateService',
    'SearchService',
    'ToolbarService',
    'AppConfiguration',
    'SearchFilterStorage',
    'SearchFilter',
    '$rootScope',
    '$location',
    '$context',
    'SearchExecution',
    'ProductViewService',
    'TranslationService',
    'ThemeWorldService'
];

function TenderController($scope, $sce, dataGen, $routeParams, searchFilter, $redirect, panelService, RFXCreateService,
                          SearchService, ToolbarService, AppConfiguration, SearchFilterStorage, SearchFilter, $rootScope,
                          $location, $context, SearchExecution, ProductViewService, TranslationService,
                          ThemeWorldService) {
    var tenderCtrl = this;
    tenderCtrl.tenderId = $routeParams.id;
    tenderCtrl.getTenderPanelColor = panelService.getTenderPanelColor;
    var scrollPositionList = 0;
    this.translationService = TranslationService;
    this.panelsInitialized = false;
    this.showScrollTopButton = false;
    this.pageNumber = 1;
    this.expandCatalogSupplierDefault = SearchService.userSearchConfig('expandCatalogSupplierDefault');
    this.expandTenderLotDefault = SearchService.userSearchConfig('expandTenderLotDefault');
    this.lotAvailable = AppConfiguration.get('lotAvailable');
    this.showSupplierSearch = AppConfiguration.get('showSupplierSearch');
    this.displayAllResultsAsList = AppConfiguration.get('displayAllResultsAsList');
    this.informationIsOpen = SearchService.userSearchConfig('informationIsOpen');
    this.freshFiltersSet = false;
    this.showPanelLabel = AppConfiguration.get('showPanelLabels');
    ToolbarService.showSearchFilterToggle();
    this.filterNeedsReset = {value: false};
    this.SearchFilter = SearchFilter;
    tenderCtrl.searchWithReset = function (item) {
        tenderCtrl.filterNeedsReset.value = true;
        SearchFilter.setSearchInputClassification(null);
        var freshFilter = SearchFilterStorage.getFreshFilter();
        if (freshFilter) {
            tenderCtrl.filter = freshFilter;
            tenderCtrl.filter.tenderId = {value: $routeParams.id};
            tenderCtrl.filter.dialogFilter = "tender";
            SearchFilterStorage.setTenderFilter($routeParams.id, tenderCtrl.filter);
            tenderCtrl.filter.searchInput.value = searchFilter.searchInput;
            if (item) {
                if (item.isClassification) {
                    tenderCtrl.filter.guidingClassification.selected = {id: item.id, value: item.value};
                }
            }
            SearchFilter.setFilters(tenderCtrl.filter);
        }
        tenderCtrl.searchAll();
    }

    var currentLocation = $location.path();
    var backButtonUsed = $rootScope.location !== currentLocation;
    var storedSearchFilterObject = SearchFilterStorage.getTenderFilter($routeParams.id);
    if (storedSearchFilterObject && ($routeParams.useSetFilter || storedSearchFilterObject.searchInputUsed || backButtonUsed)) {
        storedSearchFilterObject.searchInputUsed = false;
        tenderCtrl.filter = storedSearchFilterObject;
        searchFilter.searchInput = tenderCtrl.filter.searchInput.value;
        var guidingClassification = tenderCtrl.filter.guidingClassification;
        if (guidingClassification && guidingClassification.superEntries) {
            var superEntry = guidingClassification.superEntries[guidingClassification.superEntries.length - 1];
            SearchFilter.setSearchInputClassification(superEntry);
        }
        else {
            SearchFilter.setSearchInputClassification(null);
        }
        if(!tenderCtrl.filter.productsPerPage)
        {
            tenderCtrl.filter.productsPerPage = SearchService.getNumberOfProductRows();
        }
        SearchFilter.setFilters(tenderCtrl.filter);
        getDialogData(backButtonUsed);
    }
    else {
        SearchFilter.setSearchInputClassification(null);
        var freshFilter = SearchFilterStorage.getFreshFilter();
        if (freshFilter) {
            tenderCtrl.filter = freshFilter;
            tenderCtrl.filter.tenderId = {value: $routeParams.id};
            tenderCtrl.filter.dialogFilter = "tender";
            SearchFilterStorage.setTenderFilter($routeParams.id, tenderCtrl.filter);
            searchFilter.searchInput = tenderCtrl.filter.searchInput.value;
            SearchFilter.setFilters(tenderCtrl.filter);
            getDialogData();
        }
        else {
            var result = {};
            dataGen.getData(result, {}, "/search/filter", null, true).then(function () {
                SearchFilterStorage.setFreshFilter(result.data);
                tenderCtrl.filter = result.data;
                tenderCtrl.filter.tenderId = {value: $routeParams.id};
                tenderCtrl.filter.dialogFilter = "tender";
                SearchFilterStorage.setTenderFilter($routeParams.id, tenderCtrl.filter);
                if ($location.path() === currentLocation) {
                    //only if we are still on the vCatalog page.
                    searchFilter.searchInput = tenderCtrl.filter.searchInput.value;
                    SearchFilter.setFilters(tenderCtrl.filter);
                    getDialogData()
                }
            });
        }
    }

    function getDialogData(backButtonUsed) {
        return dataGen.getData($scope, {id: $routeParams.id}, "/tender/view").then(function () {
            tenderCtrl.searchAll(true).then(function () {
                tenderCtrl.panelsInitialized = true;
                handleNoProducts();
                if(backButtonUsed) {
                    SearchFilterStorage.scrollToSearchScrollPosition("tender", '#search-view');
                }
            });
            $scope.themeWorldActive = $scope.data.themeWorldActive;
            $scope.no_result = $scope.themeWorldActive && $scope.noSearchResults;
            $scope.description = $sce.trustAsHtml($scope.data.description);
            if ($scope.data.lots && $scope.data.lots.length === 1) {
                $scope.trns.lots = $scope.trns.lot;
            }

            if ($scope.data.suppliers && $scope.data.suppliers.length === 1) {
                $scope.trns.suppliers = $scope.trns.supplier;
            }
            $scope.trns.addToThemeWorld = TranslationService.get('addToThemeWorld');
            $scope.trns.removeFromThemeWorld = TranslationService.get('removeFromThemeWorld');
            $scope.trns.addToProductView = TranslationService.get('addToProductView');
            $scope.trns.removeFromProductView = TranslationService.get('removeFromProductView');

            defineButtons();
        });
    }

    $scope.$on('$routeChangeStart', function (event, newRoute, oldRoute) {
        var detailList = newRoute.originalPath.indexOf("/search.") > - 1;
        if (!detailList && newRoute.originalPath !== "/search") {
            SearchFilter.setSearchInputClassification(null);
            searchFilter.searchInput = "";
            if (!tenderCtrl.freshFiltersSet) {
                SearchFilter.setFilters(SearchFilterStorage.getFreshFilter());
            }
        }
        if (newRoute.$$route.originalPath !== oldRoute.$$route.originalPath) {
            SearchFilterStorage.setSearchFilterPlaceHolder(null);
            SearchFilterStorage.setSearchScrollPosition("tender", document.getElementById('search-view').scrollTop);
        }
    });


    /**
     * Set the filter for the product family
     * @param prg
     */
    tenderCtrl.filterPRG = function (prg) {
        searchFilter.searchInput = '';
        SearchFilter.setFilters(SearchFilterStorage.getFreshFilter());
        SearchFilter.getFilters().searchInput.value = '';
        SearchFilter.setProductFamily(prg);
        tenderCtrl.freshFiltersSet = true;
        $redirect.redirectTo(null, "/search");
    };

    /**
     * Set the filter for the procurement group
     * @param pg the procurement group.
     * @param prg the product family.
     */
    tenderCtrl.filterPG = function (pg, prg) {
        searchFilter.searchInput = '';
        SearchFilter.setFilters(SearchFilterStorage.getFreshFilter());
        SearchFilter.getFilters().searchInput.value = '';
        if (prg) {
            SearchFilter.setProductFamily(prg);
        }
        SearchFilter.setProcurementGroup(pg);
        tenderCtrl.freshFiltersSet = true;
        $redirect.redirectTo(null, "/search");
    };

    tenderCtrl.createScrollList = function () {
        $scope.scrollList = [];
        if (tenderCtrl.lots) {
            var numberOfLots = tenderCtrl.numberOfLots;
            if (numberOfLots > 1) {
                $scope.scrollList.push({id: "lot", label: numberOfLots + " " + $scope.trns.lots, func: openLotArea})
            }
            if (numberOfLots === 1) {
                $scope.scrollList.push({id: "lot", label: numberOfLots + " " + $scope.trns.lot, func: openLotArea})
            }
        }
        if (tenderCtrl.catalogs) {
            var numberOfVCats = tenderCtrl.numberOfCatalogs;
            if (numberOfVCats > 1) {
                $scope.scrollList.push({
                    id: "catalogsAndSuppliers",
                    label: numberOfVCats + " " + $scope.trns.vcats,
                    func: openCatalogArea
                })
            }
            if (numberOfVCats === 1) {
                $scope.scrollList.push({
                    id: "catalogsAndSuppliers",
                    label: numberOfVCats + " " + $scope.trns.vcat,
                    func: openCatalogArea
                })
            }
        }
        if (tenderCtrl.suppliers) {
            var numberOfSuppliers = tenderCtrl.numberOfSuppliers;
            if (numberOfSuppliers > 1) {
                $scope.scrollList.push({
                    id: "catalogsAndSuppliers",
                    label: numberOfSuppliers + " " + $scope.trns.suppliers,
                    func: openSupplierArea
                })
            }
            if (numberOfSuppliers === 1) {
                $scope.scrollList.push({
                    id: "catalogsAndSuppliers",
                    label: numberOfSuppliers + " " + $scope.trns.supplier,
                    func: openSupplierArea
                })
            }
        }
        var numberOfPros = tenderCtrl.numberOfProducts;
        if (numberOfPros > 1) {
            $scope.scrollList.push({id: "pro", label: numberOfPros + " " + $scope.trns.products})
        }
        if (numberOfPros === 1) {
            $scope.scrollList.push({id: "pro", label: numberOfPros + " " + $scope.trns.product})
        }
        if ($scope.scrollList.length > 0) {
            $scope.scrollList.unshift({id: "header", label: $scope.trns.headerData, func: openHeaderArea});
        }

        ToolbarService.setScrollMenu($scope.scrollList);
    };

    tenderCtrl.createRFX = function () {
        RFXCreateService.createRFX("tender", $routeParams.id);
    };


    tenderCtrl.showScrollTop = function (showScrollTop, scrollPosition) {
        tenderCtrl.showScrollTopButton = showScrollTop;
        scrollPositionList = scrollPosition;
    };

    tenderCtrl.searchProducts = function (index, selectedSort) {
        tenderCtrl.filter.productPageNumber = index;
        tenderCtrl.filter.productsPerPage = SearchService.getNumberOfProductRows();

        if (selectedSort) {
            tenderCtrl.filter.sort.selected = selectedSort;
        }
        return SearchService.searchProducts(tenderCtrl.filter.productPageNumber).then(function (searchResults) {
            if (searchResults) {
                angular.extend(tenderCtrl, searchResults);
            }
        })
    };

    tenderCtrl.searchAll = function (onInit) {
        if (!onInit && tenderCtrl.filter) {
            tenderCtrl.filter.productPageNumber = 1;
        }
        return SearchService.searchAll().then(function (searchResult) {
            angular.extend(tenderCtrl, searchResult);
            tenderCtrl.createScrollList();
            $scope.noSearchResults = searchResult.catalogs.length === 0 && (!searchResult.lots || searchResult.lots.length === 0)
                && (!searchResult.suppliers || searchResult.suppliers.length === 0) && searchResult.products.length === 0;
            $scope.no_result = $scope.themeWorldActive && $scope.noSearchResults;
        });
    };

    tenderCtrl.scrollToTop = function () {
        angular.element('#search-view').animate({
            scrollTop: scrollPositionList
        }, 200);
    };

    tenderCtrl.toggleInformation = function () {
        tenderCtrl.informationIsOpen = !tenderCtrl.informationIsOpen
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.createRFX,
                action: tenderCtrl.createRFX,
                type: 'dialogaction',
                condition: tenderCtrl.canCreateRFX
            },
            {
                label: $scope.trns.addToProductView,
                action: tenderCtrl.addToProductView,
                type: 'dialogaction',
                condition: canAddToProductView
            },
            {
                label: $scope.trns.removeFromProductView,
                action: tenderCtrl.removeFromProductView,
                type: 'dialogaction',
                condition: canRemoveFromProductView
            },
            {
                label: $scope.trns.addToThemeWorld,
                action: tenderCtrl.addToThemeWorld,
                type: 'dialogaction',
                condition: canAddToThemeWorld
            },
            {
                label: $scope.trns.removeFromThemeWorld,
                action: tenderCtrl.removeFromThemeWorld,
                type: 'dialogaction',
                condition: canRemoveFromThemeWorld
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function canAddToProductView() {
        return $scope.data.canAddToProductView;
    }

    function canRemoveFromProductView() {
        return $scope.data.canRemoveFromProductView;
    }

    function canAddToThemeWorld() {
        return $scope.data.canAddToThemeWorld;
    }

    function canRemoveFromThemeWorld() {
        return $scope.data.canRemoveFromThemeWorld;
    }

    tenderCtrl.addToProductView = function($event) {
        $scope.data.canAddToProductView = false;
        $scope.data.canRemoveFromProductView = true;
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        return ProductViewService.addTendersToProductView([$scope.data]);
    };

    tenderCtrl.removeFromProductView = function($event) {
        var vcatIds = [];
        $scope.data.canAddToProductView = true;
        $scope.data.canRemoveFromProductView = false;
        vcatIds.push($scope.data.id);
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        return ProductViewService.removeTendersFromProductView($context.hasActiveProductView.id, vcatIds);
    };

    tenderCtrl.addToThemeWorld = function($event) {
        $scope.data.canAddToThemeWorld = false;
        $scope.data.canRemoveFromThemeWorld = true;
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        return ThemeWorldService.addTendersToThemeWorld([$scope.data]);
    };

    tenderCtrl.removeFromThemeWorld = function($event) {
        var vcatIds = [];
        $scope.data.canAddToThemeWorld = true;
        $scope.data.canRemoveFromThemeWorld = false;
        vcatIds.push($scope.data.id);
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        return ThemeWorldService.removeTendersFromThemeWorld($context.hasActiveThemeWorld.id, vcatIds);
    };

    this.canCreateRFX = function () {
        return $scope.data.showRFXButton;
    }

    function openLotArea() {
        tenderCtrl.expandTenderLotDefault = true;
    }

    function openCatalogArea() {
        tenderCtrl.expandCatalogSupplierDefault = true;
        tenderCtrl.catalogPaneSelected = true;
        tenderCtrl.supplierPaneSelected = false;
    }

    function openSupplierArea() {
        tenderCtrl.expandCatalogSupplierDefault = true;
        tenderCtrl.catalogPaneSelected = false;
        tenderCtrl.supplierPaneSelected = true;
    }

    function openHeaderArea() {
        tenderCtrl.informationIsOpen = true;
    }

    $scope.$on('$destroy', function () {
        SearchService.setUserSearchConfigParameter('expandCatalogSupplierDefault', tenderCtrl.expandCatalogSupplierDefault);
        SearchService.setUserSearchConfigParameter('expandTenderLotDefault', tenderCtrl.expandTenderLotDefault);
        SearchService.setUserSearchConfigParameter('informationIsOpen', tenderCtrl.informationIsOpen);
        ToolbarService.hideSearchFilterToggle();
    });

    $scope.$on('MainSearchTriggered', function () {
        tenderCtrl.informationIsOpen = false;
    });

    tenderCtrl.updateLots = function (pageNumber, pageSize) {
        SearchFilter.setTenderId(tenderCtrl.tenderId);
        return SearchExecution.searchLots(SearchFilter.getFilters(), pageSize, pageNumber).then(function (result) {
            var numberOfResults = 0;
            if (result && result.data) {
                var searchResults = result.data.searchResults;
                tenderCtrl.lots = tenderCtrl.lots.concat(searchResults.lots);
                numberOfResults = searchResults.lots.length;
            }
            return numberOfResults;
        })
    };

    tenderCtrl.updateCatalogs = function (pageNumber, pageSize) {
        SearchFilter.setTenderId(tenderCtrl.tenderId);
        return SearchExecution.searchCatalogs(SearchFilter.getFilters(), pageSize, pageNumber).then(function (result) {
            var numberOfResults = 0;
            if (result && result.data) {
                var searchResults = result.data.searchResults;
                tenderCtrl.catalogs = tenderCtrl.catalogs.concat(searchResults.catalogs);
                numberOfResults = searchResults.catalogs.length;
            }
            return numberOfResults;
        })
    };

    tenderCtrl.updateSuppliers = function (pageNumber, pageSize) {
        SearchFilter.setTenderId(tenderCtrl.tenderId);
        return SearchExecution.searchSuppliers(SearchFilter.getFilters(), pageSize, pageNumber).then(function (result) {
            var numberOfResults = 0;
            if (result && result.data) {
                var searchResults = result.data.searchResults;
                tenderCtrl.suppliers = tenderCtrl.suppliers.concat(searchResults.suppliers);
                numberOfResults = searchResults.suppliers.length;
            }
            return numberOfResults;
        })
    };

    function handleNoProducts() {
        if (!tenderCtrl.products ||tenderCtrl.products.length == 0) {
            openSupplierArea();
        }
    }

    tenderCtrl.anyResults = function () {
        return (tenderCtrl.showSupplierSearch && tenderCtrl.suppliers && tenderCtrl.suppliers.length > 0) ||
            (tenderCtrl.lotAvailable && tenderCtrl.lots && tenderCtrl.lots.length > 0) ||
            (tenderCtrl.catalogs && tenderCtrl.catalogs.length > 0) ||
            (tenderCtrl.products && tenderCtrl.products.length > 0);
    };

    tenderCtrl.showNoResultsHint = function () {
        return !$context.hasActiveThemeWorldSearch || !$context.hasActiveThemeWorldSearch.value;
    }

    this.searchTerm = function (term) {
        SearchFilter.setFilterIdentifier();
        searchFilter.searchInput = term;

        SearchFilter.setFilters(SearchFilterStorage.getFreshFilter())

        SearchFilter.getFilters().tenderId = {value: $routeParams.id};
        SearchFilter.getFilters().dialogFilter = "tender";
        SearchFilterStorage.setTenderFilter($routeParams.id, SearchFilter.getFilters());

        searchFilter.resetDetailFilter().then(function () {
            var filterData = {};
            if ($context.hasActiveShopView.value) {
                searchFilter.listSearch.value = true;
            }
            SearchFilter.getFilters().searchInput.value = searchFilter.searchInput;
            SearchFilter.getFilters().searchInputUsed = true;
            tenderCtrl.searchWithReset();
        });
    };
}
